import React, { useEffect } from 'react';
import { isValidObject } from 'common/utilities/utils';
import { validatCardJSX } from '../sharedTemplates/ValidateCardTempate';
const ValidateCard = props => {
  const { retryCountForGetOrderStatus } = props;
  useEffect(() => {
    const progressBarContainer = document.getElementById('progressBarContainer');
    const progressBar = document.getElementById('progressBar');
    if (progressBarContainer && progressBar) {
      const width = (progressBarContainer?.offsetWidth / 3) * retryCountForGetOrderStatus.orderStatus;
      if (isValidObject(progressBar?.style)) {
        progressBar.style.width = width + 'px';
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryCountForGetOrderStatus]);

  return validatCardJSX(props);
};

export default React.memo(ValidateCard);
